module.exports = __webpack_public_path__ + "static/img/sousuo.0e16e9cb.png";